import {
  reservationService,
  bankCardService,
  cineCashBalance,
  cineCashPaymentService,
  movieYelmoPaymentService,
  paypalOrderService,
  getBizumService,
  getRedsysService,
  bizumServiceValidate,
  redsysServiceValidate,
  visaCheckOutDecryptService,
  visaCheckoutService,
  annualPassService,
  priceZeroService,
  spreedlyService,
  getAppleWalletService,
  deleteOrderService
} from '../services';
import { showModal } from './ui';
import { requestError } from './globals';
import fileSaver from 'file-saver';
/*
  Constants
*/
const CLOSE_MODAL_SPREEDLY = 'CLOSE_MODAL_SPREEDLY';
export const SET_SESSIONID_PAYMENTS = 'SET_SESSIONID_PAYMENTS';
export const REMOVE_SESSIONID_PAYMENTS = 'REMOVE_SESSIONID_PAYMENTS';
const CINECASH_BALANCE_REQUEST = 'CINECASH_BALANCE_REQUEST';
const CINECASH_BALANCE_RESPONSE_SUCCESS = 'CINECASH_BALANCE_RESPONSE_SUCCESS';
const CLEAR_PAYMENT_RESPONSE = 'CLEAR_PAYMENT_RESPONSE';
const PAYMENT_REQUEST = 'PAYMENT_REQUEST';
const PAYMENT_RESPONSE = 'PAYMENT_RESPONSE';
const VISA_CHECKOUT_DECRYPT_RESPONSE = 'VISA_CHECKOUT_DECRYPT_RESPONSE';
const VISA_CHECKOUT_DECRYPT_REQUEST = 'VISA_CHECKOUT_DECRYPT_REQUEST';
const SET_TOKEN_RECAPTCHA = 'SET_TOKEN_RECAPTCHA';
const SET_PAYMENT_TYPE = 'SET_PAYMENT_TYPE';
const APPLEWALLET_SUCCESS = 'APPLEWALLET_SUCCESS';
const REQUEST_PAYMENTS_ERROR = 'REQUEST_PAYMENTS_ERROR';

/*
  Action creators
*/

function _base64ToArrayBuffer(base64) {
  var binary_string = window.atob(base64);
  var len = binary_string.length;
  var bytes = new Uint8Array(len);
  for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
  }
  return bytes.buffer;
}

export const getAppleWallet = (obj) => (dispatch) => {
  dispatch(paymentRequest());
  getAppleWalletService(obj).then(response => {
    if (typeof response.status_code === 'undefined'){      
      var pass = _base64ToArrayBuffer(response);
      let blob = new Blob([pass],{type:'application/vnd.apple.pkpass'});
      fileSaver.saveAs(blob, 'pass.pkpass');
    }
    dispatch({ type: APPLEWALLET_SUCCESS });
  });
}
export const closeModalSpreedly = () => ({type:CLOSE_MODAL_SPREEDLY});
export const setPaymentType = (paymentType) => ({
  type: SET_PAYMENT_TYPE,
  paymentType,
  metadata: { local: 'save' }
});
export const paymentRequest = () => ({ type: PAYMENT_REQUEST });
export const clearPaymentResponse = () => ({ type: CLEAR_PAYMENT_RESPONSE });
export const setSessionId = (sessionId) => ({ type: SET_SESSIONID_PAYMENTS, sessionId, metadata: { local: 'save' } });
export const setTokenRecaptcha = (token) => ({ type: SET_TOKEN_RECAPTCHA, tr: token });
export const removeSessionId = () => ({ type: REMOVE_SESSIONID_PAYMENTS, metadata: { local: 'save' } });
export const requestReservation = (data, sessionId, tokenR) => (dispatch, getState) => {
  if (getState().payments.isLoading) return;

  dispatch({ type: PAYMENT_REQUEST });
  dispatch({ type: CLEAR_PAYMENT_RESPONSE });
  
  reservationService(data, getState().globals.sessionId, tokenR)
    .then((response) => {
      const baseActionResult = { type: PAYMENT_RESPONSE, payload: response.data, sessionId };

      if (response.data.status_code === 0) {
        if (response.data.tickets_confirmation.status === 0)
          dispatch({ ...baseActionResult, metadata: { local: 'clearAll' } });
      } else {
        dispatch(baseActionResult);
        dispatch(showModal({ type: 'error payment', position: 'aside' }));
      }
    });
};

export const requestBankCard = (data, sessionId, fingerprintId, tokenR) => (dispatch, getState) => {
  if (getState().payments.isLoading) return;

  dispatch({ type: PAYMENT_REQUEST });
  bankCardService(data, getState().globals.sessionId, fingerprintId, '', tokenR)
    .then((response) => {
      const baseActionResult = { type: PAYMENT_RESPONSE, payload: response.data, sessionId };

      if (response.data.status_code === 0) {
        if (response.data.tickets_confirmation.status === 0)
          dispatch({ ...baseActionResult, metadata: { local: 'clearAll' } });
      } else {
        dispatch(baseActionResult);
        dispatch(showModal({ type: 'error payment', position: 'aside' }));
      }
    });
};

export const requestSpreedly = (data, sessionId, fingerprintId, paymentMethod, tokenR, firstSixDigits) => (dispatch, getState) => {
  dispatch({ type: PAYMENT_REQUEST });
  spreedlyService(data, sessionId, fingerprintId, paymentMethod, tokenR, firstSixDigits).then((response) => {
    const baseActionResult = { type: PAYMENT_RESPONSE, payload: response.data, sessionId };
    if (response.data.status_code === 0 && response.data.tickets_confirmation.status === 0) {
        dispatch({ ...baseActionResult, metadata: { local: 'clearAll' } });
    } else {
      dispatch(baseActionResult);
      dispatch(showModal({ type: 'error payment', position: 'aside' }));
    }
  });
};

export const requestCineCashBalance = (accessToken) => (dispatch, getState) => {
  if (getState().payments.isLoading) return;

  dispatch({ type: CINECASH_BALANCE_REQUEST });
  cineCashBalance(accessToken).then((response) => {
    dispatch({ type: CINECASH_BALANCE_RESPONSE_SUCCESS, payload: response.data, metadata: { local: 'save' } });
  });
};

export const requestCineCashPayment = (data, sessionId, accessToken, cinemaName, movieName, loyaltyCard, tokenR) => (dispatch, getState) => {
  if (getState().payments.isLoading) return;
  dispatch({ type: PAYMENT_REQUEST });
  cineCashPaymentService(data, sessionId, accessToken, cinemaName, movieName, loyaltyCard, tokenR).then((response) => {
    const baseActionResult = { type: PAYMENT_RESPONSE, payload: response.data, sessionId };

    if (response.data.status_code === 0 && response.data.tickets_confirmation.status === 0) {
        dispatch({ ...baseActionResult, metadata: { local: 'clearAll' } });
    } else {
      dispatch(baseActionResult);
      dispatch(showModal({ type: 'error payment', position: 'aside' }));
    }
  });
};

export const requestMovieYelmoPayment = (data, sessionId, pin, loyaltyNumber, tokenR) => (dispatch, getState) => {

  if (getState().payments.isLoading) return;
  dispatch({ type: PAYMENT_REQUEST });
  movieYelmoPaymentService(data, sessionId, pin, loyaltyNumber, tokenR).then((response) => {
    const baseActionResult = { type: PAYMENT_RESPONSE, payload: response.data, sessionId };

    if (response.data.status_code === 0 && response.data.tickets_confirmation.status === 0)
      dispatch({ ...baseActionResult, metadata: { local: 'clearAll' } });
    else {
      dispatch(baseActionResult);
      dispatch(showModal({ type: 'error payment', position: 'aside' }));
    }
  });

};

export const requestPaypalOrder = (sessionId, tickets, amount, cinemaVistaId, bill_to, tokenR, concessions, bookingFee) => (dispatch, getState) => {
  if (getState().payments.isLoading) return;
  dispatch({
    type: PAYMENT_REQUEST
  });
  paypalOrderService(sessionId, tickets, amount, cinemaVistaId, tokenR, concessions, bookingFee).then((response) => {
    dispatch({ type: PAYMENT_RESPONSE, payload: response.data, bill_to, metadata: { local: 'save' } });
  });

};

export const requestBizumOrder = (countryCode, sessionId, showtimeId, cinemaId, loyaltyCard, paymentType, billTo, tokenR) => (dispatch, getState) => {
  if (getState().payments.isLoading) return;
  dispatch({
    type: PAYMENT_REQUEST
  });
  getBizumService(countryCode, sessionId, showtimeId, cinemaId, loyaltyCard, paymentType, billTo, tokenR).then((response) => {
    dispatch({ type: PAYMENT_RESPONSE, payload: response.data, billTo, metadata: { local: 'save' } });
  });
};

export const requestRedsysOrder = (countryCode, sessionId, showtimeId, cinemaId, loyaltyCard, paymentType, billTo, tokenR) => (dispatch, getState) => {
  if (getState().payments.isLoading) return;
  dispatch({
    type: PAYMENT_REQUEST
  });
  getRedsysService(countryCode, sessionId, showtimeId, cinemaId, loyaltyCard, paymentType, billTo, tokenR).then((response) => {
    dispatch({ type: PAYMENT_RESPONSE, payload: response.data, billTo, metadata: { local: 'save' } });
  });
};

export const requestBizum = (countryCode, sessionId, showtimeId, cinemaId, loyaltyCard, paymentType, merchantOrderId, billTo) => (dispatch, getState) => {
  if (getState().payments.isLoading) return;
  dispatch({ type: PAYMENT_REQUEST });
  bizumServiceValidate(countryCode, sessionId, showtimeId, cinemaId, loyaltyCard, paymentType, merchantOrderId, billTo).then((response) => {
    const baseActionResult = { type: PAYMENT_RESPONSE, payload: response.data, bill_to: billTo, sessionId };

    if (response.data.status_code === 0 && response.data.tickets_confirmation.status === 0) { 
      dispatch({ ...baseActionResult, metadata: { local: 'clearAll' } });
    } else {
      deleteOrderService(sessionId);
      dispatch({ ...baseActionResult, metadata: { local: 'clearAll' } });
    }
  }).catch(e => {
    if(e.response) {
      const { data, status } = e.response
      const code = data.status_code || status 
      dispatch(requestError(code, data.message));
    } else console.log(e)
  });
};

export const requestRedsys = (countryCode, sessionId, showtimeId, cinemaId, loyaltyCard, paymentType, merchantOrderId, billTo) => (dispatch, getState) => {
  if (getState().payments.isLoading) return;
  dispatch({ type: PAYMENT_REQUEST });
  redsysServiceValidate(countryCode, sessionId, showtimeId, cinemaId, loyaltyCard, paymentType, merchantOrderId, billTo).then((response) => {
    const baseActionResult = { type: PAYMENT_RESPONSE, payload: response.data, bill_to: billTo, sessionId };

    if (response.data.status_code === 0 && response.data.tickets_confirmation.status === 0) {      
      dispatch({ ...baseActionResult, metadata: { local: 'clearAll' } });
    } else {
      deleteOrderService(sessionId);
      dispatch({ ...baseActionResult, metadata: { local: 'clearAll' } });
    }
  }).catch(e => {
    if(e.response) {
      const { data, status } = e.response
      const code = data.status_code || status 
      dispatch(requestError(code, data.message));
    } else console.log(e)
  });
};

export const loadingFormPayment = () =>  (dispatch) => {
  dispatch({ type: PAYMENT_REQUEST });
}

export const requestVisaCheckOutDecrypt = (data, wrappedKey, callId) => (dispatch, getState) => {
  if (getState().payments.isLoading) return;
  dispatch({ type: VISA_CHECKOUT_DECRYPT_REQUEST, data, wrappedKey, callId });
  visaCheckOutDecryptService(data, wrappedKey).then((response) => {
    if (response.data.status_code === 0)
      dispatch({ type: VISA_CHECKOUT_DECRYPT_RESPONSE, payload: response.data, metadata: { local: 'save' } });
    else {
      dispatch({ type: VISA_CHECKOUT_DECRYPT_RESPONSE, payload: response.data });
      dispatch(showModal({ type: 'error payment', position: 'aside' }));
    }
  });
};

export const requestVisaCheckout = (data, wrappedKey, billTo, callId, card, cinema, fingerPrintId, loyaltyCard, movie, sessionId) => (dispatch, getState) => {
  if (getState().payments.isLoading) return;
  dispatch({ type: PAYMENT_REQUEST });
  visaCheckoutService(data, wrappedKey, billTo, callId, card, cinema, fingerPrintId, loyaltyCard, movie, sessionId)
    .then((response) => {
      const baseActionResult = { type: PAYMENT_RESPONSE, payload: response.data, sessionId };

      if (response.data.status_code === 0 && response.data.tickets_confirmation.status === 0) {
          dispatch({ ...baseActionResult, metadata: { local: 'clearAll' } });
      } else {
        dispatch(baseActionResult);
        dispatch(showModal({ type: 'error payment', position: 'aside' }));
      }
    });
};

export const requestAnnualPassPayment = (data, sessionId, tokenR) => (dispatch, getState) => {
  if (getState().payments.isLoading) return;

  dispatch({ type: PAYMENT_REQUEST });
  annualPassService(data, getState().globals.sessionId, tokenR)
    .then((response) => {
      const baseActionResult = { type: PAYMENT_RESPONSE, payload: response.data, sessionId };

      if (response.data.status_code === 0 && response.data.tickets_confirmation.status === 0) {
          dispatch({ ...baseActionResult, metadata: { local: 'clearAll' } });
      } else {
        dispatch(baseActionResult);
        dispatch(showModal({ type: 'error payment', position: 'aside' }));
      }
    });
};

export const requestPriceZeroPayment = (data, sessionId, tokenR) => (dispatch, getState) => {
  if (getState().payments.isLoading) return;

  dispatch({ type: PAYMENT_REQUEST });
  priceZeroService(data, getState().globals.sessionId, tokenR)
    .then((response) => {
      const baseActionResult = { type: PAYMENT_RESPONSE, payload: response.data, sessionId };

      if (response.data.status_code === 0 && response.data.tickets_confirmation.status === 0) {        
          dispatch({ ...baseActionResult, metadata: { local: 'clearAll' } });
      } else {
        dispatch(baseActionResult);
        dispatch(showModal({ type: 'error payment', position: 'aside' }));
      }
    });
};



/*
  Reducer
*/
const initialState = {
  isLoading: false,
  sessionId: null,
  bill_to: null,
  paymentResponse: {},
  cineCashBalance: null,
  visaCheckoutDecryptResponse: null,
  visaCheckOutData: null,
  visaCheckOutCallId: null,
  visaCheckOutWrappedKey: null,
  tr: null,
  type:null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case PAYMENT_REQUEST:
      return { ...state, isLoading: true };
    case PAYMENT_RESPONSE:
      return { ...state, isLoading: false, paymentResponse: action.payload, bill_to: action.bill_to };
    case SET_SESSIONID_PAYMENTS:
      return { ...state, sessionId: action.sessionId };
    case REMOVE_SESSIONID_PAYMENTS:
      return { ...state, sessionId: null };
    case CLEAR_PAYMENT_RESPONSE:
      return { ...state, paymentResponse: {}, visaCheckoutDecryptResponse: null, visaCheckOutData: null, visaCheckOutCallId: null, visaCheckOutWrappedKey: null };
    case CINECASH_BALANCE_RESPONSE_SUCCESS:
      return { ...state, isLoading: false, cineCashBalance: action.payload };
    case VISA_CHECKOUT_DECRYPT_RESPONSE:
      return { ...state, isLoading: false, visaCheckoutDecryptResponse: action.payload };
    case VISA_CHECKOUT_DECRYPT_REQUEST:
      return { ...state, isLoading: true, visaCheckOutData: action.data, visaCheckOutWrappedKey: action.wrappedKey, visaCheckOutCallId: action.callId };
    case SET_TOKEN_RECAPTCHA:
      return { ...state, tr: action.tr };
    case SET_PAYMENT_TYPE:
      return { ...state, isLoading: false, type: action.paymentType };
    case CLOSE_MODAL_SPREEDLY:
      return { ...state, isLoading: false };
    case APPLEWALLET_SUCCESS:
      return { ...state, isLoading: false };
    case REQUEST_PAYMENTS_ERROR:
      return {...state, isLoading: false }
    default:
      return state;
  }
};
